export default "__VITE_ASSET__DjxDaK32__"